import { render, staticRenderFns } from "./sysDistributor.vue?vue&type=template&id=67b3e308&scoped=true"
import script from "./sysDistributor.vue?vue&type=script&lang=js"
export * from "./sysDistributor.vue?vue&type=script&lang=js"
import style0 from "./sysDistributor.vue?vue&type=style&index=0&id=67b3e308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3e308",
  null
  
)

export default component.exports